// Foresight checklist work view (/ennakointi, #630): foresight_scope and change_drivers.
// Step 3 (scenarios.v2) is in foresightScenarioStrings.js.
// Merged into fi/en/sv as `foresight`.

export const foresightFi = {
  pageTitle: 'Ennakointi',
  pageLead: 'Rajaa tarkasteltava asia, valitse muutosvoimat, muodosta niistä skenaarion tulevaisuuskuvat ja rakenna tavoiteltavasta tulevaisuudesta polku nykyhetkeen. Tekoäly ehdottaa, sinä päätät.',
  selectInstance: 'Valitse ensin Kuutio.',
  loading: 'Ladataan…',
  loadFailed: 'Lataus epäonnistui: {{error}}',
  noForesightSteps: 'Tämän Kuution kulussa ei ole ennakointivaiheita. Lisää ne Kulku-sivulla (ryhmä Ennakointi).',
  blocked: 'Edellinen vaihe on kesken: {{step}}.',
  goToStep: 'Siirry vaiheeseen',
  done: 'valmis',
  common: {
    save: 'Tallenna',
    saving: 'Tallennetaan…',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
    accept: 'Hyväksy',
    reject: 'Hylkää',
    restore: 'Palauta',
    remove: 'Poista',
    add: 'Lisää',
    discard: 'Hylkää luonnos',
    rejectReason: 'Miksi hylkäät? (vapaaehtoinen, tallentuu muistiin)',
    rejectSave: 'Hylkää ja tallenna syy',
    rejectedBecause: 'Hylkäyksen syy',
    approvedAt: 'Hyväksytty {{date}}',
    failed: 'Tekoäly ei onnistunut: {{error}}',
    sources: 'Lähteet',
    sourcesUnavailable: 'Tietopohja ei vastannut, joten ehdotuksilla ei ole lähteitä.',
    rejectedTitle: 'Hylätyt ({{n}})',
    actionFailed: 'Toiminto epäonnistui: {{error}}',
  },
  stages: {
    queued: 'Jonossa…',
    structuring: 'Jäsennetään rajausta…',
    searching: 'Haetaan tietopohjasta…',
    suggesting: 'Tunnistetaan muutosvoimia…',
    pruning: 'Karsitaan muutosvoimia…',
    generating: 'Muodostetaan skenaarioita…',
    saving: 'Tallennetaan…',
    assessing: 'Arvioidaan erilaisuutta…',
    composing: 'Luonnostellaan tavoiteltavaa tulevaisuutta…',
    drafting: 'Laaditaan apukysymyksiä ja luonnoksia…',
    reviewing: 'Arvioidaan toimintapolkua…',
    wildcards: 'Etsitään villejä kortteja…',
    testing: 'Stressitestataan polkua…',
    metric: 'Etsitään mittaria…',
    working: 'Tekoäly työskentelee…',
  },
  steps: {
    foresight_scope: 'Rajaus',
    change_drivers: 'Muutosvoimat',
    scenarios: 'Tulevaisuuskuvat',
    preferred_future: 'Tavoiteltava tulevaisuus',
    backcasting: 'Backcasting',
    wildcard_test: 'Villi kortti',
  },
  scope: {
    title: 'Rajaus ja lähtötiedot',
    lead: 'Kuvaa tarkasteltava asia omin sanoin. Tekoäly jäsentää kuvauksen, kysyy puuttuvat tiedot ja nostaa esiin oletukset, joita kuvaus pitää itsestäänselvinä.',
    useType: 'Mitä tarkastellaan?',
    useTypes: {
      service: 'Palvelu', project: 'Hanke', operating_model: 'Toimintamalli', strategy: 'Strategia', decision: 'Päätösasia',
    },
    fields: {
      subjectName: 'Tarkasteltava asia',
      description: 'Lyhyt kuvaus',
      goal: 'Tavoite tarkasteltavalle asialle',
      currentState: 'Nykytila',
      challenges: 'Keskeiset haasteet',
      whyForesight: 'Miksi ennakointia tarvitaan juuri tässä?',
      scopeLimits: 'Mitä jätetään tarkastelun ulkopuolelle?',
      stakeholders: 'Käyttäjät ja sidosryhmät (yksi per rivi)',
    },
    horizon: 'Aikajänne',
    horizonYears: '{{n}} vuotta',
    targetYear: 'Tavoitevuosi',
    structure: 'Jäsennä tekoälyllä',
    suggestionsTitle: 'Tekoälyn ehdotukset kenttiin',
    useSuggestion: 'Käytä',
    useAll: 'Käytä kaikki',
    questionsTitle: 'Tekoäly kysyy',
    assumptionsTitle: 'Lähtöoletukset',
    assumptionsLead: 'Tekoälyn tunnistamat oletukset, joita kuvaus pitää itsestäänselvinä. Ne, joita et hylkää, otetaan huomioon seuraavissa vaiheissa ja tallentuvat raporttiin. Hylkää oletus, joka ei pidä paikkaansa: hylätty jätetään pois jatkotarkastelusta.',
    checkTitle: 'Rajauksen arvio',
    checkVerdicts: { ok: 'Rajaus riittää', tighten: 'Tarkenna tavoitetta', too_broad: 'Liian laaja' },
    checkStale: 'Rajausta on muokattu arvion jälkeen — jäsennä uudelleen.',
    checkUseGoal: 'Käytä tavoitteena',
    checkGoalChosen: 'Valittu tavoitteeksi',
    checkSuggestionsLead: 'Tekoäly ehdottaa tarkempia tavoitteita. Valitse yksi, niin se korvaa tavoitekentän sisällön. Jos haluat yhdistää useamman, muokkaa tavoitekenttää itse. Tallenna lopuksi.',
    questionsLead: 'Tekoälyn apukysymykset tavoitevuoden pohtimiseen. Niihin ei tarvitse vastata: käytä niitä, jos ne nostavat esiin jotain, mikä rajauksesta vielä puuttuu.',
    fieldHints: {
      goal: 'Mitä tarkasteltavalla asialla tavoitellaan tavoitevuonna. Ei tämän harjoituksen tavoite.',
      scopeLimits: 'Kirjaa vain rajaukset, jotka ohjaavat seuraavia vaiheita ja tuovat niihin lisäarvoa.',
    },
    keepAssumption: 'Pidä',
    dropAssumption: 'Hylkää',
    approve: 'Hyväksy rajaus',
    approvedNote: 'Rajaus on hyväksytty. Jos muutat sitä, hyväksyntä poistuu ja se annetaan uudelleen; myöhempien vaiheiden sisältö säilyy.',
    needSubject: 'Kirjoita tarkasteltava asia ennen hyväksyntää.',
  },
  drivers: {
    title: 'Muutosvoimat',
    lead: 'Tekoäly ehdottaa rajauksen ja tietopohjan perusteella muutosvoimia. Valitse niistä 3–4 tärkeintä (enintään 7); niistä tulee skenaarioiden muuttujat.',
    suggest: 'Ehdota muutosvoimia',
    suggestMore: 'Ehdota lisää',
    add: 'Lisää oma muutosvoima',
    newTitle: 'Muutosvoiman nimi',
    newDescription: 'Kuvaus (vapaaehtoinen)',
    approvedTitle: 'Valitut muutosvoimat',
    approvedLead: 'Aseta valitsemasi muutosvoimat nuolten avulla tärkeysjärjestykseen: ylimmäksi se, jonka asiantuntemuksesi perusteella arvioit keskeisimmäksi tarkasteltavan asian kannalta koko ajanjakson aikana. Tekoäly saa muutosvoimat tässä järjestyksessä, ja ne näkyvät raportissa samassa järjestyksessä.',
    suggestedTitle: 'Ehdotukset',
    empty: 'Ei vielä muutosvoimia. Pyydä ehdotuksia tai lisää oma.',
    count: '{{n}} valittu',
    countOk: 'Skenaarioiden pohja on valmis.',
    countLow: 'Valitse vähintään 3.',
    countMany: 'Suositus on 3–4 tärkeintä: jokainen valittu muutosvoima kuvataan jokaisessa tulevaisuuskuvassa, joten suuri joukko laimentaa niitä.',
    countHigh: 'Valitse enintään 7.',
    prune: 'Auta karsimaan',
    pruneTitle: 'Karsintaehdotus',
    pruneKeep: 'Säilytä: {{titles}}',
    pruneReject: 'Hylkää tällä perusteella',
    pruneSkip: 'Säilytä silti',
    pruneClose: 'Sulje',
    moveUp: 'Siirrä ylös',
    moveDown: 'Siirrä alas',
    unapprove: 'Palauta ehdotuksiin',
    categories: {
      megatrend: 'Megatrendi', trend: 'Trendi', weak_signal: 'Heikko signaali', local: 'Paikallinen tekijä', other: 'Muu',
    },
    impacts: { positive: 'Myönteinen', negative: 'Kielteinen', uncertain: 'Epävarma' },
    category: 'Tyyppi',
    impact: 'Vaikutus',
  },
  report: {
    briefIntro: 'Mitä ennakointi tarkasteli, miksi ja millä aikajänteellä.',
    driversIntro: 'Muutosvoimat, joiden varaan skenaarion tulevaisuuskuvat rakennettiin, asiantuntijan tärkeysjärjestyksessä ja lähteineen.',
    scenariosIntro: 'Kunkin skenaarion tekoälyn muodostamat ja käyttäjän muokkaamat ja hyväksymät tulevaisuuskuvat. Ne ovat ajattelun välineitä, eivät ennusteita.',
    assumptionsIntro: 'Oletukset, joiden varaan työ rakentui, ja hylätyt vaihtoehdot perusteluineen. Kun palaat työhön myöhemmin, tarkista, pitävätkö ne yhä.',
    scenarioAssumptions: 'Tulevaisuuskuvan "{{title}}" oletukset',
    rejectedTitle: 'Hylätyt vaihtoehdot',
  },
  admin: {
    statusDone: 'Valmis',
    statusOpen: 'Kesken',
  },
};

export const foresightEn = {
  pageTitle: 'Foresight',
  pageLead: 'Scope the subject, choose the change drivers, build the scenario\'s future images from them and work back from a preferred future to the present. The AI suggests; you decide.',
  selectInstance: 'Select a Kuutio first.',
  loading: 'Loading…',
  loadFailed: 'Loading failed: {{error}}',
  noForesightSteps: 'This Kuutio\'s flow has no foresight steps. Add them on the Flow page (group Foresight).',
  blocked: 'The previous step is unfinished: {{step}}.',
  goToStep: 'Go to step',
  done: 'done',
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    edit: 'Edit',
    accept: 'Accept',
    reject: 'Reject',
    restore: 'Restore',
    remove: 'Remove',
    add: 'Add',
    discard: 'Discard',
    rejectReason: 'Why are you rejecting it? (optional, kept on record)',
    rejectSave: 'Reject and save the reason',
    rejectedBecause: 'Reason for rejection',
    approvedAt: 'Approved {{date}}',
    failed: 'The AI did not succeed: {{error}}',
    sources: 'Sources',
    sourcesUnavailable: 'The knowledge base did not respond, so the suggestions have no sources.',
    rejectedTitle: 'Rejected ({{n}})',
    actionFailed: 'The action failed: {{error}}',
  },
  stages: {
    queued: 'Queued…',
    structuring: 'Structuring the brief…',
    searching: 'Searching the knowledge base…',
    suggesting: 'Identifying change drivers…',
    pruning: 'Pruning the drivers…',
    generating: 'Building scenarios…',
    saving: 'Saving…',
    assessing: 'Assessing how different they are…',
    composing: 'Drafting the preferred future…',
    drafting: 'Writing questions and drafts…',
    reviewing: 'Reviewing the path…',
    wildcards: 'Looking for wild cards…',
    testing: 'Stress-testing the path…',
    metric: 'Finding a metric…',
    working: 'The AI is working…',
  },
  steps: {
    foresight_scope: 'Scope',
    change_drivers: 'Change drivers',
    scenarios: 'Future images',
    preferred_future: 'Preferred future',
    backcasting: 'Backcasting',
    wildcard_test: 'Wild card',
  },
  scope: {
    title: 'Scope and starting information',
    lead: 'Describe the subject in your own words. The AI structures it, asks for what is missing and surfaces the assumptions your description takes for granted.',
    useType: 'What is being examined?',
    useTypes: {
      service: 'Service', project: 'Project', operating_model: 'Operating model', strategy: 'Strategy', decision: 'Decision',
    },
    fields: {
      subjectName: 'Subject',
      description: 'Short description',
      goal: 'Goal for the subject',
      currentState: 'Current state',
      challenges: 'Key challenges',
      whyForesight: 'Why is foresight needed here?',
      scopeLimits: 'What is left out of scope?',
      stakeholders: 'Users and stakeholders (one per line)',
    },
    horizon: 'Time horizon',
    horizonYears: '{{n}} years',
    targetYear: 'Target year',
    structure: 'Structure with AI',
    suggestionsTitle: 'AI suggestions for the fields',
    useSuggestion: 'Use',
    useAll: 'Use all',
    questionsTitle: 'The AI asks',
    assumptionsTitle: 'Starting assumptions',
    assumptionsLead: 'Assumptions the AI found your description takes for granted. The ones you don\'t drop are used in the later steps and saved to the report. Drop an assumption that doesn\'t hold: a dropped one is left out of the rest of the work.',
    checkTitle: 'Scope assessment',
    checkVerdicts: { ok: 'The scope is sufficient', tighten: 'Sharpen the goal', too_broad: 'Too broad' },
    checkStale: 'The scope has changed since the assessment — structure it again.',
    checkUseGoal: 'Use as the goal',
    checkGoalChosen: 'Chosen as the goal',
    checkSuggestionsLead: 'The AI suggests sharper goals. Choose one and it replaces the goal field. To combine several, edit the goal field yourself. Save when done.',
    questionsLead: 'The AI\'s questions for thinking about the target year. You don\'t have to answer them: use them if they bring up something the scope still lacks.',
    fieldHints: {
      goal: 'What the subject aims for by the target year. Not the goal of this exercise.',
      scopeLimits: 'Record only limits that guide the next steps and add value to them.',
    },
    keepAssumption: 'Keep',
    dropAssumption: 'Reject',
    approve: 'Approve scope',
    approvedNote: 'The scope is approved. Changing it removes the approval, to be given again; the later steps keep their content.',
    needSubject: 'Write the subject before approving.',
  },
  drivers: {
    title: 'Change drivers',
    lead: 'The AI suggests change drivers from the brief and the knowledge base. Choose the 3–4 most important (at most 7); they become the scenarios\' variables.',
    suggest: 'Suggest change drivers',
    suggestMore: 'Suggest more',
    add: 'Add your own driver',
    newTitle: 'Driver name',
    newDescription: 'Description (optional)',
    approvedTitle: 'Chosen drivers',
    approvedLead: 'Put your chosen drivers in order of importance with the arrows: at the top, the one your expertise tells you is the most central for the subject over the whole period. The AI gets the drivers in this order, and the report lists them in the same order.',
    suggestedTitle: 'Suggestions',
    empty: 'No drivers yet. Ask for suggestions or add your own.',
    count: '{{n}} chosen',
    countOk: 'The basis for the scenarios is ready.',
    countLow: 'Choose at least 3.',
    countMany: 'The recommendation is the 3–4 most important: every chosen driver is described in every future image, so a large set dilutes them.',
    countHigh: 'Choose at most 7.',
    prune: 'Help me prune',
    pruneTitle: 'Pruning recommendation',
    pruneKeep: 'Keep: {{titles}}',
    pruneReject: 'Reject with this reason',
    pruneSkip: 'Keep it anyway',
    pruneClose: 'Close',
    moveUp: 'Move up',
    moveDown: 'Move down',
    unapprove: 'Back to suggestions',
    categories: {
      megatrend: 'Megatrend', trend: 'Trend', weak_signal: 'Weak signal', local: 'Local factor', other: 'Other',
    },
    impacts: { positive: 'Positive', negative: 'Negative', uncertain: 'Uncertain' },
    category: 'Type',
    impact: 'Impact',
  },
  report: {
    briefIntro: 'What the foresight work examined, why, and over which time horizon.',
    driversIntro: "The change drivers each scenario's future images were built on, in the expert's order of importance, with their sources.",
    scenariosIntro: "Each scenario's future images, built by the AI and edited and approved by the user. They are thinking tools, not forecasts.",
    assumptionsIntro: 'The assumptions the work rests on, and the alternatives rejected with their reasons. When you return to the work later, check whether they still hold.',
    scenarioAssumptions: 'Assumptions of the future image "{{title}}"',
    rejectedTitle: 'Rejected alternatives',
  },
  admin: {
    statusDone: 'Done',
    statusOpen: 'In progress',
  },
};

export const foresightSv = {
  pageTitle: 'Framsyn',
  pageLead: 'Avgränsa det som granskas, välj förändringskrafterna, bygg scenariots framtidsbilder av dem och arbeta dig från en önskad framtid tillbaka till nuet. AI:n föreslår, du bestämmer.',
  selectInstance: 'Välj en Kuutio först.',
  loading: 'Laddar…',
  loadFailed: 'Laddningen misslyckades: {{error}}',
  noForesightSteps: 'Den här Kuutions flöde har inga framsynssteg. Lägg till dem på sidan Flöde (gruppen Framsyn).',
  blocked: 'Föregående steg är ofärdigt: {{step}}.',
  goToStep: 'Gå till steget',
  done: 'klart',
  common: {
    save: 'Spara',
    saving: 'Sparar…',
    cancel: 'Avbryt',
    edit: 'Redigera',
    accept: 'Godkänn',
    reject: 'Avvisa',
    restore: 'Återställ',
    remove: 'Ta bort',
    add: 'Lägg till',
    discard: 'Avfärda utkastet',
    rejectReason: 'Varför avvisar du? (frivilligt, sparas)',
    rejectSave: 'Avvisa och spara orsaken',
    rejectedBecause: 'Orsak till avvisningen',
    approvedAt: 'Godkänd {{date}}',
    failed: 'AI:n lyckades inte: {{error}}',
    sources: 'Källor',
    sourcesUnavailable: 'Kunskapsbasen svarade inte, så förslagen saknar källor.',
    rejectedTitle: 'Avvisade ({{n}})',
    actionFailed: 'Åtgärden misslyckades: {{error}}',
  },
  stages: {
    queued: 'I kö…',
    structuring: 'Strukturerar avgränsningen…',
    searching: 'Söker i kunskapsbasen…',
    suggesting: 'Identifierar förändringskrafter…',
    pruning: 'Gallrar förändringskrafterna…',
    generating: 'Bygger scenarier…',
    saving: 'Sparar…',
    assessing: 'Bedömer hur olika de är…',
    composing: 'Skissar den önskade framtiden…',
    drafting: 'Skriver hjälpfrågor och utkast…',
    reviewing: 'Granskar handlingsvägen…',
    wildcards: 'Letar efter wild cards…',
    testing: 'Stresstestar vägen…',
    metric: 'Söker en mätare…',
    working: 'AI:n arbetar…',
  },
  steps: {
    foresight_scope: 'Avgränsning',
    change_drivers: 'Förändringskrafter',
    scenarios: 'Framtidsbilder',
    preferred_future: 'Önskad framtid',
    backcasting: 'Backcasting',
    wildcard_test: 'Wild card',
  },
  scope: {
    title: 'Avgränsning och utgångsdata',
    lead: 'Beskriv det som granskas med egna ord. AI:n strukturerar beskrivningen, frågar efter det som saknas och lyfter fram antaganden som beskrivningen tar för givna.',
    useType: 'Vad granskas?',
    useTypes: {
      service: 'Tjänst', project: 'Projekt', operating_model: 'Verksamhetsmodell', strategy: 'Strategi', decision: 'Beslutsärende',
    },
    fields: {
      subjectName: 'Det som granskas',
      description: 'Kort beskrivning',
      goal: 'Mål för det som granskas',
      currentState: 'Nuläge',
      challenges: 'Centrala utmaningar',
      whyForesight: 'Varför behövs framsyn just här?',
      scopeLimits: 'Vad lämnas utanför?',
      stakeholders: 'Användare och intressenter (en per rad)',
    },
    horizon: 'Tidshorisont',
    horizonYears: '{{n}} år',
    targetYear: 'Målår',
    structure: 'Strukturera med AI',
    suggestionsTitle: 'AI:ns förslag till fälten',
    useSuggestion: 'Använd',
    useAll: 'Använd alla',
    questionsTitle: 'AI:n frågar',
    assumptionsTitle: 'Utgångsantaganden',
    assumptionsLead: 'Antaganden som AI:n har sett att beskrivningen tar för givna. De du inte avvisar används i de följande stegen och sparas i rapporten. Avvisa ett antagande som inte stämmer: ett avvisat lämnas utanför det fortsatta arbetet.',
    checkTitle: 'Bedömning av avgränsningen',
    checkVerdicts: { ok: 'Avgränsningen räcker', tighten: 'Precisera målet', too_broad: 'För bred' },
    checkStale: 'Avgränsningen har ändrats efter bedömningen — strukturera på nytt.',
    checkUseGoal: 'Använd som mål',
    checkGoalChosen: 'Valt som mål',
    checkSuggestionsLead: 'AI:n föreslår skarpare mål. Välj ett, så ersätter det innehållet i målfältet. Vill du kombinera flera, redigera målfältet själv. Spara till sist.',
    questionsLead: 'AI:ns hjälpfrågor för att fundera på målåret. Du behöver inte svara på dem: använd dem om de lyfter fram något som avgränsningen ännu saknar.',
    fieldHints: {
      goal: 'Vad det som granskas strävar efter till målåret. Inte målet för den här övningen.',
      scopeLimits: 'Skriv bara avgränsningar som styr de följande stegen och ger dem mervärde.',
    },
    keepAssumption: 'Behåll',
    dropAssumption: 'Avvisa',
    approve: 'Godkänn avgränsningen',
    approvedNote: 'Avgränsningen är godkänd. Om du ändrar den tas godkännandet bort och ges på nytt; de senare stegens innehåll finns kvar.',
    needSubject: 'Skriv vad som granskas innan du godkänner.',
  },
  drivers: {
    title: 'Förändringskrafter',
    lead: 'AI:n föreslår förändringskrafter utifrån avgränsningen och kunskapsbasen. Välj de 3–4 viktigaste (högst 7); de blir scenariernas variabler.',
    suggest: 'Föreslå förändringskrafter',
    suggestMore: 'Föreslå fler',
    add: 'Lägg till en egen',
    newTitle: 'Förändringskraftens namn',
    newDescription: 'Beskrivning (frivillig)',
    approvedTitle: 'Valda förändringskrafter',
    approvedLead: 'Ordna de valda förändringskrafterna efter vikt med pilarna: överst den som du utifrån din expertis bedömer som mest central för det som granskas under hela perioden. AI:n får förändringskrafterna i den här ordningen, och rapporten visar dem i samma ordning.',
    suggestedTitle: 'Förslag',
    empty: 'Inga förändringskrafter ännu. Be om förslag eller lägg till en egen.',
    count: '{{n}} valda',
    countOk: 'Underlaget för scenarierna är klart.',
    countLow: 'Välj minst 3.',
    countMany: 'Rekommendationen är de 3–4 viktigaste: varje vald förändringskraft beskrivs i varje framtidsbild, så en stor mängd urvattnar dem.',
    countHigh: 'Välj högst 7.',
    prune: 'Hjälp mig gallra',
    pruneTitle: 'Gallringsförslag',
    pruneKeep: 'Behåll: {{titles}}',
    pruneReject: 'Avvisa med denna motivering',
    pruneSkip: 'Behåll ändå',
    pruneClose: 'Stäng',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ner',
    unapprove: 'Tillbaka till förslagen',
    categories: {
      megatrend: 'Megatrend', trend: 'Trend', weak_signal: 'Svag signal', local: 'Lokal faktor', other: 'Övrig',
    },
    impacts: { positive: 'Positiv', negative: 'Negativ', uncertain: 'Osäker' },
    category: 'Typ',
    impact: 'Påverkan',
  },
  report: {
    briefIntro: 'Vad framsynsarbetet granskade, varför och med vilken tidshorisont.',
    driversIntro: 'Förändringskrafterna som scenariots framtidsbilder byggdes på, i expertens prioritetsordning och med källor.',
    scenariosIntro: 'Varje scenarios framtidsbilder, byggda av AI:n och redigerade och godkända av användaren. De är tankeverktyg, inte prognoser.',
    assumptionsIntro: 'Antagandena som arbetet bygger på och de avvisade alternativen med motiveringar. När du återvänder till arbetet senare, kontrollera om de fortfarande håller.',
    scenarioAssumptions: 'Antaganden i framtidsbilden "{{title}}"',
    rejectedTitle: 'Avvisade alternativ',
  },
  admin: {
    statusDone: 'Klart',
    statusOpen: 'Pågår',
  },
};
